var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-wrapper "},[_c('div',{staticClass:"user-pic"},[_c('img',{attrs:{"src":_vm.image,"alt":"alt"}})]),_c('div',{staticClass:"name"},[_vm._t("p-1")],2),_c('div',{staticClass:"card-btn"},[_vm._t("p-2")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }